//Constants
export const productionStepId = { 'PALLET_SCAN': 0, 'PRODUCT_SCAN': 1, 'EXTRA': 2 };
export const productionSteps = [
    { id: 0, code: 'PALLET_SCAN', name: 'Scanned pallet', description: 'Scan je pallet (sscc)', required: true },
    { id: 1, code: 'PRODUCT_SCAN', name: 'Scanned product', description: 'Scan je product (GTIt)', required: true },
    { id: 2, code: 'EXTRA', name: 'Change palletnumber', description: 'Problemen...', required: true }
];

export const roles = { 'ADMIN_ROLE': 13, };
export const workstationTypes = { "PALLETBOX_VALIDATION": 1, "MANUAL_VALIDATION": 2};

export const productionStepDescription = { 'PALLET_SCAN': 'Scan je pallet (sscc)', 'PRODUCT_SCAN': 'Scan je product', 'EXTRA': 'Problemen?' };
export const notificationTypes = { 'PROBLEM': 1, 'CLEANING': 2, 'MACHINESTART': 3, "MACHINESTOP": 4, "MACHINESTANDBY": 5 };
export const actions = { 'SEARCH_SSCC': 1, 'ACTIVE_SSCC': 2, 'SEARCH_PRODUCT': 3, 'PRINT_PREVIEW': 4 };
export const searchTypes = { 'SSCC': 1, 'PRODUCT': 2 };
export const historyTableColumns = { 'PALLET': 0, 'PRODUCT': 1, 'BARCODE': 2, 'QUANTITY': 3, 'QUALITY': 4, 'ORDER': 5, 'LOCATION': 6, 'CREATEDON': 7 };
export const eventHistoryTableColumns = { 'EVENTDATE': 0, 'EVENTTYPE': 1, 'SSCC': 2, 'PRODUCTNUMBER': 3, 'PRODUCTDESCRIPTION': 4, 'CHECKPOINT': 5, 'USERNAME': 6, 'SUCCEEDED': 7};
export const printHistoryTableColumns = { 'ORDERNUMBER': 0, 'NEWSSCC': 1, 'OLDSSCC': 2, 'PRINTDATE': 3, 'OPERATOR': 4, 'PRODUCTNUMBER': 5, 'PRODUCTDESCRIPTION': 6, 'CHECKPOINT': 7 };

export const metisUserTableColumns = {'ID': 0, 'NAME': 1, 'EMAIL': 2, 'ROLE': 3, 'FEATURE': 4, 'BADGENUMBER': 5};
export const bagweigherUserTableColumns = {'ID': 0, 'NAME': 1, 'EMAIL': 2, 'FUNCTION': 3, 'BADGENUMBER': 4, 'ISACTIVE': 5, 'RECEIVEMAILS' : 6};

export const systemParameters = { 'VersionNumber': 8, 'ServicesDashboardUrl': 11, 'TransportDashboardUrl': 12 };


